import React, { useEffect, useState } from "react";
import "./css/hero.css";
import videoBg from "../media/videos/hero.mp4";
//import FloatingButtons from "../footandnavbar/FloatingButtons";
import AvailabilityBar from "./AvailabilityBar";
import Rooms from "./Rooms";
import StorySection from "./StorySection";
import Gallery from "./Gallery";
import Testimonial from "./Testimonial";
import { Link } from "react-router-dom";

const Hero = () => {
  const [text, setText] = useState("");
  const fullText = "Retreat on Mutungo Hill";

  useEffect(() => {
    let i = 0;
    const typing = setInterval(() => {
      setText(fullText.substring(0, i + 1));
      i++;
      if (i === fullText.length) clearInterval(typing);
    }, 60);
  }, []);

  return (
    <>
    <section className="hero">
      
      {/* VIDEO */}
      <video autoPlay loop muted playsInline className="hero-video">
        <source src={videoBg} type="video/mp4" />
      </video>

      {/* OVERLAY */}
      <div className="overlay2"></div>

      {/* CONTENT */}
      <div className="hero-content">
        
        <p className="top-text fade-in">
            <span>★</span>
          MUTUNGO HILL · LAKE VICTORIA
          <span>★</span>
        </p>

        <h1 className="hero-title fade-in delay-1">
          A Peaceful Christian <br />
          <span className="typing">{text}</span>
        </h1>

        <p className="hero-desc fade-in delay-2">
          Rest, reflect, and reconnect in a serene hilltop sanctuary with
          comfortable accommodation, warm hospitality, and breathtaking views
          of Lake Victoria.
        </p>

        <div className="hero-buttons fade-in delay-3">
          <button className="primary-btn"> <Link to="/rooms">BOOK YOUR STAY</Link></button>
          <button className="secondary-btn"> <Link to="/retreats">PLAN A RETREAT</Link></button>
        </div>

        {/* SCROLL INDICATOR */}
        <div className="scroll-indicator">
          <span>SCROLL</span>
          <div className="arrow-down"></div>
        </div>

      </div>
      
    </section>
    
    <AvailabilityBar />
    <Rooms/>
    <StorySection />
    <Gallery />
    <Testimonial />
    </>
  );
};

export default Hero;